<template>
  <div v-show="showMobileMenu" class="menuFooterMobile">
    <div v-if="isLoginPopupShown" class="userLoginPopup">
      <span @click="isLoginPopupShown = false" class="userPopupClose">&times;</span>
      <UserPopupNotLogged :dictionary="dictionary" :is-pwa="isPwa" class="userForm" :langDefault="langDefault" />
    </div>

    <ul>
      <li>
        <a href="#" title="Kategorie" tabindex="-1" @click="openMenuCategory">
          <svg width="25" height="21" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.3124 1.05051H0.525254C0.385948 1.05051 0.252346 0.99517 0.153842 0.896666C0.0553377 0.798162 0 0.66456 0 0.525254C0 0.385948 0.0553377 0.252349 0.153842 0.153845C0.252346 0.0553403 0.385948 0 0.525254 0H18.3124C18.4518 0 18.5854 0.0553403 18.6839 0.153845C18.7824 0.252349 18.8377 0.385948 18.8377 0.525254C18.8377 0.66456 18.7824 0.798162 18.6839 0.896666C18.5854 0.99517 18.4518 1.05051 18.3124 1.05051Z" fill="#333333"/>
            <path d="M18.3124 8.05576H0.525254C0.385948 8.05576 0.252346 8.00042 0.153842 7.90192C0.0553377 7.80341 0 7.66981 0 7.5305C0 7.3912 0.0553377 7.2576 0.153842 7.1591C0.252346 7.06059 0.385948 7.00525 0.525254 7.00525H18.3124C18.4518 7.00525 18.5854 7.06059 18.6839 7.1591C18.7824 7.2576 18.8377 7.3912 18.8377 7.5305C18.8377 7.66981 18.7824 7.80341 18.6839 7.90192C18.5854 8.00042 18.4518 8.05576 18.3124 8.05576Z" fill="#333333"/>
            <path d="M18.3124 15H0.525254C0.385948 15 0.252346 14.9446 0.153842 14.8461C0.0553377 14.7476 0 14.614 0 14.4747C0 14.3354 0.0553377 14.2018 0.153842 14.1033C0.252346 14.0048 0.385948 13.9495 0.525254 13.9495H18.3124C18.4518 13.9495 18.5854 14.0048 18.6839 14.1033C18.7824 14.2018 18.8377 14.3354 18.8377 14.4747C18.8377 14.614 18.7824 14.7476 18.6839 14.8461C18.5854 14.9446 18.4518 15 18.3124 15Z" fill="#333333"/>
          </svg>
          <span class="label">{{ dictionary.siteHeader.category }}</span>
        </a>
      </li>
      <li>
        <a href="#" title="Search" tabindex="-1" @click="focusSearch">
          <svg width="25" height="25" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.42766 10.8549C2.43482 10.8549 0 8.42012 0 5.42766C0 2.4352 2.43482 0 5.42766 0C8.4205 0 10.8557 2.43521 10.8557 5.42804C10.8557 8.42088 8.4205 10.8549 5.42766 10.8549ZM5.42766 0.945784C4.54126 0.945858 3.67479 1.20877 2.9378 1.70127C2.20082 2.19378 1.62643 2.89376 1.28725 3.7127C0.948078 4.53164 0.859352 5.43276 1.0323 6.30213C1.20525 7.17149 1.63209 7.97005 2.25887 8.59683C2.88565 9.22361 3.68421 9.65046 4.55358 9.82341C5.42294 9.99635 6.32406 9.90763 7.143 9.56845C7.96194 9.22927 8.66192 8.65488 9.15443 7.9179C9.64693 7.18091 9.90984 6.31444 9.90992 5.42804C9.90862 4.23971 9.43595 3.10042 8.59563 2.26018C7.75532 1.41993 6.616 0.947364 5.42766 0.946162V0.945784Z" fill="#333333"/>
            <path d="M15.1182 16C15.0561 16.0001 14.9946 15.9879 14.9372 15.9641C14.8798 15.9404 14.8277 15.9055 14.7838 15.8615L8.46976 9.54748C8.38359 9.45832 8.33589 9.33888 8.33693 9.21489C8.33797 9.0909 8.38768 8.97228 8.47533 8.88457C8.56299 8.79687 8.68157 8.7471 8.80556 8.74599C8.92956 8.74488 9.04903 8.79251 9.13824 8.87863L15.4523 15.1927C15.5184 15.2588 15.5635 15.343 15.5817 15.4347C15.6 15.5264 15.5907 15.6215 15.5549 15.7079C15.5192 15.7943 15.4586 15.8682 15.3809 15.9202C15.3031 15.9722 15.2117 15.9999 15.1182 16Z" fill="#333333"/>
          </svg>
          <span class="label">{{ dictionary.siteHeader.search.label }}</span>
        </a>
      </li>
      <li>
        <a :href="dictionary.url.cartStep1" title="Košík" tabindex="-1" class="basket">
          <svg width="27" height="25" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.5034 22C17.0262 22 16.5596 21.8585 16.1628 21.5933C15.7659 21.3282 15.4566 20.9513 15.274 20.5104C15.0913 20.0694 15.0435 19.5842 15.1366 19.1161C15.2298 18.648 15.4596 18.218 15.7971 17.8805C16.1346 17.543 16.5645 17.3132 17.0327 17.2201C17.5008 17.127 17.986 17.1747 18.4269 17.3574C18.8679 17.54 19.2448 17.8493 19.5099 18.2462C19.7751 18.643 19.9166 19.1096 19.9166 19.5869C19.9159 20.2267 19.6615 20.8401 19.2091 21.2925C18.7566 21.7449 18.1432 21.9994 17.5034 22ZM17.5034 18.468C17.282 18.468 17.0656 18.5337 16.8815 18.6567C16.6974 18.7797 16.5539 18.9546 16.4692 19.1591C16.3845 19.3637 16.3624 19.5888 16.4056 19.806C16.4488 20.0231 16.5555 20.2226 16.7121 20.3791C16.8687 20.5356 17.0682 20.6422 17.2854 20.6853C17.5025 20.7285 17.7276 20.7062 17.9322 20.6214C18.1367 20.5366 18.3115 20.3931 18.4344 20.2089C18.5574 20.0248 18.6229 19.8083 18.6228 19.5869C18.6228 19.2899 18.5049 19.0051 18.295 18.795C18.0851 18.5849 17.8004 18.4667 17.5034 18.4665V18.468Z" fill="#333333"/>
            <path d="M9.48452 22C9.00724 22 8.54068 21.8585 8.14383 21.5933C7.74699 21.3282 7.43769 20.9513 7.25504 20.5104C7.0724 20.0694 7.02461 19.5842 7.11772 19.1161C7.21083 18.648 7.44066 18.218 7.77815 17.8805C8.11564 17.543 8.54562 17.3132 9.01373 17.2201C9.48184 17.127 9.96705 17.1747 10.408 17.3574C10.849 17.54 11.2258 17.8493 11.491 18.2462C11.7562 18.643 11.8977 19.1096 11.8977 19.5869C11.8971 20.2267 11.6427 20.8402 11.1903 21.2926C10.7378 21.7451 10.1244 21.9995 9.48452 22ZM9.48452 18.468C9.2631 18.468 9.04667 18.5337 8.86257 18.6567C8.67848 18.7797 8.53501 18.9546 8.4503 19.1591C8.36559 19.3637 8.34345 19.5888 8.38668 19.806C8.42992 20.0231 8.53658 20.2226 8.69318 20.3791C8.84978 20.5356 9.04928 20.6422 9.26646 20.6853C9.48363 20.7285 9.70872 20.7062 9.91325 20.6214C10.1178 20.5366 10.2926 20.3931 10.4155 20.2089C10.5384 20.0248 10.604 19.8083 10.6039 19.5869C10.6039 19.2899 10.486 19.0051 10.2761 18.795C10.0662 18.5849 9.78149 18.4667 9.48452 18.4665V18.468Z" fill="#333333"/>
            <path d="M20.6007 16.2292H9.0182C8.42863 16.2297 7.85775 16.0224 7.40577 15.6439C6.95378 15.2653 6.64957 14.7397 6.54655 14.1592L4.43354 2.33296C4.38171 2.04137 4.2288 1.77737 4.00165 1.58733C3.77451 1.39728 3.48767 1.29335 3.19151 1.29379H0.646893C0.475326 1.29379 0.310785 1.22563 0.189469 1.10432C0.0681529 0.983001 0 0.81846 0 0.646894C0 0.475327 0.0681529 0.310789 0.189469 0.189473C0.310785 0.068157 0.475326 9.56645e-07 0.646893 9.56645e-07H3.19151C3.79128 -0.000518089 4.37207 0.210192 4.83199 0.595158C5.2919 0.980124 5.60156 1.51476 5.70663 2.10525L7.81964 13.932C7.86963 14.2133 8.01711 14.468 8.2362 14.6514C8.45528 14.8348 8.73196 14.9352 9.01768 14.9349H20.6002C20.7717 14.9349 20.9363 15.0031 21.0576 15.1244C21.1789 15.2457 21.2471 15.4103 21.2471 15.5818C21.2471 15.7534 21.1789 15.9179 21.0576 16.0393C20.9363 16.1606 20.7717 16.2287 20.6002 16.2287L20.6007 16.2292Z" fill="#333333"/>
            <path d="M18.7905 12.1668H6.78109C6.60952 12.1668 6.44498 12.0987 6.32366 11.9773C6.20235 11.856 6.1342 11.6915 6.1342 11.5199C6.1342 11.3484 6.20235 11.1838 6.32366 11.0625C6.44498 10.9412 6.60952 10.873 6.78109 10.873H18.7905C19.0364 10.8724 19.2762 10.7965 19.4776 10.6553C19.6789 10.5142 19.8322 10.3147 19.9166 10.0838L21.908 4.59817H5.34758C5.17601 4.59817 5.01147 4.53001 4.89015 4.4087C4.76884 4.28738 4.70068 4.12284 4.70068 3.95127C4.70068 3.77971 4.76884 3.61517 4.89015 3.49385C5.01147 3.37254 5.17601 3.30438 5.34758 3.30438H22.1068C22.2924 3.30433 22.4754 3.34901 22.6401 3.43466C22.8049 3.5203 22.9466 3.64439 23.0532 3.7964C23.1598 3.94841 23.2282 4.12389 23.2527 4.30795C23.2771 4.49202 23.2568 4.67925 23.1935 4.85382L21.1338 10.5242C20.9585 11.0051 20.6398 11.4205 20.2207 11.7143C19.8016 12.0081 19.3023 12.1661 18.7905 12.1668Z" fill="#333333"/>
          </svg>

          <div id="js-cart-box">
            <div v-if="totalPrice" id="js-cart-price-mobile" class="label">{{ $formatCurrency(totalPrice) }}</div>
            <div v-else class="label">{{ dictionary.siteHeader.basket }}</div>
            <span v-show="totalAmount > 0" id="js-cart-amount-mobile" class="menuFooterMobile__count font-weight-bold">
                    {{ totalAmount }}
                  </span>
          </div>
        </a>
      </li>
      <li v-show="isChatEnabled" class="chatZendesk">
        <a :href="dictionary.url.contact" title="Chat" tabindex="-1" @click="openZendesk">
          <svg width="23" height="23" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.51289 15C5.97494 15.004 4.47361 14.53 3.21604 13.6432C2.98319 13.7295 2.47281 14.0378 2.15343 14.2309C1.82421 14.4299 1.48513 14.6353 1.20374 14.7734C0.968426 14.8897 0.478458 15.1317 0.161189 14.8037C-0.214117 14.4162 0.113347 13.7757 0.656432 12.7159C0.841798 12.3537 1.14184 11.7682 1.19811 11.5332C0.429661 10.3289 0.0222892 8.92905 0.0243576 7.49981C0.0243576 3.36429 3.38347 0 7.51218 0C11.6409 0 15 3.36429 15 7.49981C15 11.6353 11.6416 15 7.51289 15ZM3.28322 12.7402C3.40317 12.7378 3.52058 12.7749 3.61738 12.8459C4.74698 13.6756 6.11213 14.1212 7.51289 14.1174C11.1566 14.1174 14.1214 11.1481 14.1214 7.49805C14.1214 3.84803 11.1566 0.879038 7.51289 0.879038C3.86922 0.879038 0.904409 3.84838 0.904409 7.49805C0.902464 8.79107 1.2802 10.0561 1.99058 11.1357C2.23997 11.5148 1.98776 12.0458 1.4394 13.1161C1.33388 13.3205 1.19319 13.5953 1.07993 13.8401C1.29097 13.7207 1.52418 13.5808 1.69899 13.4751C2.43166 13.0344 2.91847 12.7402 3.28322 12.7402Z" fill="#333333"/>
          </svg>

          <span class="label">{{ dictionary.siteHeader.chat }}</span>
        </a>
      </li>
      <li v-if="userAuthentication">
        <a :href="dictionary.url.user.profile" :title="username" tabindex="-1">
          <svg width="25" height="25" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.10736 7.63733C5.3521 7.63733 4.6138 7.41337 3.98583 6.99377C3.35785 6.57417 2.8684 5.97777 2.57938 5.28C2.29035 4.58223 2.21473 3.81443 2.36207 3.07368C2.50942 2.33294 2.87311 1.65251 3.40716 1.11846C3.94121 0.584412 4.62163 0.22072 5.36238 0.0733765C6.10313 -0.0739675 6.87093 0.00165397 7.5687 0.29068C8.26647 0.579705 8.86287 1.06915 9.28247 1.69713C9.70207 2.32511 9.92603 3.0634 9.92603 3.81867C9.92491 4.83109 9.52223 5.80174 8.80633 6.51763C8.09043 7.23353 7.11979 7.63621 6.10736 7.63733ZM6.10736 0.880717C5.52621 0.880717 4.9581 1.05305 4.47489 1.37593C3.99168 1.69881 3.61508 2.15773 3.39269 2.69466C3.17031 3.23158 3.11214 3.8224 3.22555 4.39238C3.33895 4.96236 3.61883 5.48592 4.02979 5.89683C4.44076 6.30775 4.96435 6.58757 5.53435 6.7009C6.10434 6.81424 6.69515 6.756 7.23204 6.53355C7.76894 6.31111 8.22782 5.93444 8.55064 5.45119C8.87346 4.96795 9.04573 4.39982 9.04566 3.81867C9.04473 3.0397 8.73485 2.29291 8.184 1.74213C7.63316 1.19135 6.88633 0.881555 6.10736 0.880717Z" fill="#333333"/>
            <path d="M12.4265 15H0V14.5598C0 11.1338 2.78723 8.34656 6.21325 8.34656C9.63927 8.34656 12.4265 11.1338 12.4265 14.5598V15ZM0.898323 14.1196H11.5282C11.3039 11.3838 9.00577 9.22481 6.21325 9.22481C3.42074 9.22481 1.12299 11.3838 0.898323 14.1196Z" fill="#333333"/>
          </svg>

          <span class="label">{{ username }}</span>
        </a>
      </li>
      <li v-if="!userAuthentication">
        <a href="#" :title="userBoxTitle" @click="openLoginPopup" tabindex="-1">
          <svg width="25" height="25" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.10736 7.63733C5.3521 7.63733 4.6138 7.41337 3.98583 6.99377C3.35785 6.57417 2.8684 5.97777 2.57938 5.28C2.29035 4.58223 2.21473 3.81443 2.36207 3.07368C2.50942 2.33294 2.87311 1.65251 3.40716 1.11846C3.94121 0.584412 4.62163 0.22072 5.36238 0.0733765C6.10313 -0.0739675 6.87093 0.00165397 7.5687 0.29068C8.26647 0.579705 8.86287 1.06915 9.28247 1.69713C9.70207 2.32511 9.92603 3.0634 9.92603 3.81867C9.92491 4.83109 9.52223 5.80174 8.80633 6.51763C8.09043 7.23353 7.11979 7.63621 6.10736 7.63733ZM6.10736 0.880717C5.52621 0.880717 4.9581 1.05305 4.47489 1.37593C3.99168 1.69881 3.61508 2.15773 3.39269 2.69466C3.17031 3.23158 3.11214 3.8224 3.22555 4.39238C3.33895 4.96236 3.61883 5.48592 4.02979 5.89683C4.44076 6.30775 4.96435 6.58757 5.53435 6.7009C6.10434 6.81424 6.69515 6.756 7.23204 6.53355C7.76894 6.31111 8.22782 5.93444 8.55064 5.45119C8.87346 4.96795 9.04573 4.39982 9.04566 3.81867C9.04473 3.0397 8.73485 2.29291 8.184 1.74213C7.63316 1.19135 6.88633 0.881555 6.10736 0.880717Z" fill="#333333"/>
            <path d="M12.4265 15H0V14.5598C0 11.1338 2.78723 8.34656 6.21325 8.34656C9.63927 8.34656 12.4265 11.1338 12.4265 14.5598V15ZM0.898323 14.1196H11.5282C11.3039 11.3838 9.00577 9.22481 6.21325 9.22481C3.42074 9.22481 1.12299 11.3838 0.898323 14.1196Z" fill="#333333"/>
          </svg>

          <span class="label">{{ userBoxTitle }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import UserPopupNotLogged from "../elements/UserPopupNotLogged.vue";

export default {
  components: {
    UserPopupNotLogged,
  },

  props: {
    userBoxTitle: {
      type: String,
      default: null,
    },

    userBoxLink: {
      type: String,
      default: null,
    },

    totalAmount: {
      type: Number,
      default: 0,
    },

    totalPrice: {
      type: Number,
      default: 0,
    },

    userAuthentication: {
      type: Boolean,
      default: false,
    },

    isPwa: {
      type: Boolean,
      default: false,
    },

    username: {
      type: String,
      default: "",
    },

    langDefault: {
      type: String,
      default: "",
    },
    dictionary: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      showMobileMenu: true,
      isLoginPopupShown: false,
      isChatEnabled: true,
    }
  },

  ready() {

    document.getElementById('js-search-form-inp').focusout()

    window.addEventListener('resize', function () {
      document.getElementById('js-search-form-inp').focusout()
    })
  },

  methods: {
    deleteCookie(name) {
      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },

    openMenuCategory(e) {
      e.preventDefault()
      this.$emit('toggleMenu')
    },

    openZendesk(e) {
      if (window.chat) {
        e.preventDefault();

        if (this.langDefault === 'cz') {
          window.loadAndOpenAmioChat();
        } else {
          window.loadAndOpenZendeskChat();
        }
      } else {
        return true;
      }
    },

    logout() {
      this.deleteCookie("accessToken")
      return true
    },

    openLoginPopup(e) {
      e.preventDefault();
      this.isLoginPopupShown = true;
    },

    focusSearch(e) {
      e.preventDefault()
      document.getElementById('js-search-form-q').focus()
      document.body.classList.remove('header-sticky')
      document.body.classList.add('header-quick')
      document.body.classList.add("noscroll");
      document.getElementById('js-search-form-inp')?.addEventListener('focusout', function () {
        document.body.classList.remove('header-quick')
        document.body.classList.remove("noscroll");
        document.getElementsByClassName('menuFooterMobile')[0].style.display = 'block'
      })
    },
  },
}
</script>

<style lang="scss">
.userPopupClose {
  float: right;
  padding-right: 1.5rem;
  font-size: 2rem;
  cursor: pointer;
}

.userLoginPopup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #fff;
  z-index: 312;
}

.userForm {
  width: 100vw;
  max-width: 420px;
  margin: auto;
  display: block !important;
  position: static;
  padding: 4rem 2rem;
  box-shadow: none;
}

.menuFooterMobile {
  position: fixed;
  background: #FFF4F2;
  box-shadow: 0 -1px 10px 1px #00000014;
  width: 100%;
  z-index: 311;
  bottom: 0;

  @media (min-width: 768px) {
    display: none;
  }

  &.small {
    padding-bottom: 35px;
  }

  .label {
    margin: 5px 0;
    overflow: hidden;
    white-space: nowrap;
    font-size: 12px;
  }

  ul {
    display: flex;
    margin: 0;
    padding: 0;

    li {
      list-style-type: none;
      width: 100%;
      align-items: flex-end;
      display: flex;
      justify-content: center;

      a {
        padding: 10px;
        display: grid;
        flex-direction: column;
        text-align: center;
        align-items: flex-end;
        color: #333;
        grid-auto-rows: 50% 60%;
        transition: all 0.5ms;
        width: 100%;
        height: 100%;
        text-decoration: none;

        svg {
          margin: auto;
        }
      }
    }
  }

  &__count {
    background:  #e6007e;
    position: absolute;
    color: white;
    width: 17px;
    height: 17px;
    border-radius: 17px;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 4px;
    right: 19px;
  }
}
.basket {
  position: relative;
}
</style>
